// handleTimeConv.js
export function convHhmmFromUtc(hhmmUtc, tzName = "Europe/Lisbon", dataStr = null) {

  // recebe: string hh:mm (horário utc), string fusoHorario, string dd/mm/aaaa
  // retorna: hh:mm (horário local)

  const [hh, mm] = hhmmUtc.split(":").map(Number);

  let y, m, d;
  if (dataStr) {
    const [dd, MM, yyyy] = dataStr.split("/").map(Number);
    y = yyyy; m = MM - 1; d = dd;
  } else {
    const hoje = new Date();
    y = hoje.getUTCFullYear();
    m = hoje.getUTCMonth();
    d = hoje.getUTCDate();
  }

  const dtUtc = new Date(Date.UTC(y, m, d, hh, mm));

  return new Intl.DateTimeFormat("pt-PT", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: tzName
  }).format(dtUtc);
}

export function convHhmmToUtc(hhmmLocal, tzName = "Europe/Lisbon", dataStr = null) {

  // recebe: string hh:mm (horário local), string fusoHorario, string dd/mm/aaaa
  // retorna: hh:mm (horário UTC)

  const [hh, mm] = hhmmLocal.split(":").map(Number);

  let y, m, d;
  if (dataStr) {
    const [dd, MM, yyyy] = dataStr.split("/").map(Number);
    y = yyyy; m = MM - 1; d = dd;
  } else {
    const hoje = new Date();
    y = hoje.getUTCFullYear();
    m = hoje.getUTCMonth();
    d = hoje.getUTCDate();
  }

  // cria data "como se fosse UTC"
  const dt = new Date(Date.UTC(y, m, d, hh, mm));

  // obtém o mesmo instante no fuso desejado
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: tzName,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });

  const parts = fmt.formatToParts(dt);
  const hLocal = Number(parts.find(p => p.type === "hour").value);
  const mLocal = Number(parts.find(p => p.type === "minute").value);

  // diferença entre "interpretado" e "esperado"
  const offsetMin = (hLocal - hh) * 60 + (mLocal - mm);

  // ajusta para UTC real
  const dtUtc = new Date(dt.getTime() - offsetMin * 60000);

  return dtUtc.toISOString().slice(11, 16); // "HH:MM"
}

export function convFromUtc(dtUtcIso, tzName = "Europe/Lisbon") {

    if (!dtUtcIso) {
        throw new Error("dtUtcIso obrigatório");
    }

    const dtUtc = new Date(dtUtcIso);

    if (isNaN(dtUtc.getTime())) {
        throw new Error(`Datetime inválido: ${dtUtcIso}`);
    }

    const hhmm = new Intl.DateTimeFormat("pt-PT", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: tzName
    }).format(dtUtc);

    const dataStr = new Intl.DateTimeFormat("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: tzName
    }).format(dtUtc);

    return {
        hhmm,
        dataStr
    };
}

export function convHhmmToUtcIso_v2(
    hhmmLocal,
    dataStr,
    tzName = "Europe/Lisbon"
) {

    const [hh, mm] = hhmmLocal.split(":").map(Number);
    const [dd, MM, yyyy] = dataStr.split("/").map(Number);

    // estimativa inicial UTC
    const guessUtc = new Date(Date.UTC(
        yyyy,
        MM - 1,
        dd,
        hh,
        mm,
        0
    ));

    const localParts = new Intl.DateTimeFormat("en-GB", {
        timeZone: tzName,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    }).formatToParts(guessUtc);

    const p = {};
    localParts.forEach(el => {
        if (el.type !== "literal") {
            p[el.type] = el.value;
        }
    });

    const localAsUtcMs = Date.UTC(
        Number(p.year),
        Number(p.month) - 1,
        Number(p.day),
        Number(p.hour),
        Number(p.minute)
    );

    const offsetMs = localAsUtcMs - guessUtc.getTime();

    const utcReal = new Date(guessUtc.getTime() - offsetMs);

    return utcReal.toISOString();
}

export function convDdMmYyyyHhmmToIso(dtStr) {
    // recebe: "dd/mm/aaaa-hh:mm"
    // retorna: ISO UTC sem conversão de fuso

    if (!dtStr) {
        throw new Error("dtStr obrigatório");
    }

    const [dataStr, hhmm] = dtStr.split("-");
    const [dd, MM, yyyy] = dataStr.split("/").map(Number);
    const [hh, mm] = hhmm.split(":").map(Number);

    const dtUtc = new Date(
        Date.UTC(
            yyyy,
            MM - 1,
            dd,
            hh,
            mm,
            0,
            0
        )
    );

    if (isNaN(dtUtc.getTime())) {
        throw new Error(`Datetime inválido: ${dtStr}`);
    }

    return dtUtc.toISOString();
}